import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@/core/api/type'
import { MessagingQueryKey } from '../../keys'
import MessagingService from '../services'
import { GetAutoMessageResponse } from '../../types'

function useQueryGetAutoMessageById(
	id: string,
	props?: UseBaseQueryOptions<GetAutoMessageResponse>,
) {
	return useQuery({
		queryKey: [MessagingQueryKey.GetAutoMessageById, id],
		queryFn: () => MessagingService.getAutoMessageById(id),
		enabled: !!id,
		...props,
	})
}

export default useQueryGetAutoMessageById
